import {
  DomainSessionId,
  DomainUserId,
  Email,
  SessionId,
  UserId,
  ZipCode,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const ZIP_CODE = 'ZIP_CODE';
export const SESSION_ID = 'SESSION_ID';
export const USER_ID = 'USER_ID';
export const DOMAIN_SESSION_ID = 'DOMAIN_SESSION_ID';
export const DOMAIN_USER_ID = 'DOMAIN_USER_ID';
export const HOUSEHOLD_INCOME = 'HOUSEHOLD_INCOME';
export const HOUSEHOLD_SIZE = 'HOUSEHOLD_SIZE';
export const DOB = 'DOB';
export const TOBACCO = 'TOBACCO';
export const EMAIL = 'EMAIL';
export const PLAN_YEAR = 'PLAN_YEAR';

export const ANSWERS = [
  ZIP_CODE,
  HOUSEHOLD_INCOME,
  HOUSEHOLD_SIZE,
  DOB,
  TOBACCO,
  EMAIL,
  SESSION_ID,
  USER_ID,
  DOMAIN_SESSION_ID,
  DOMAIN_USER_ID,
  PLAN_YEAR,
] as const;

export type Answers = (typeof ANSWERS)[number];

export const ZIP_CODE_SCHEMA = ZipCode;
export type ZipCodeType = z.infer<typeof ZIP_CODE_SCHEMA>;

export const PLAN_YEAR_SCHEMA = z.string().min(4).max(4);
export type PlanYearType = z.infer<typeof PLAN_YEAR_SCHEMA>;

export const HOUSEHOLD_INCOME_SCHEMA = z.number().min(1);
export type HouseholdIncomeType = z.infer<typeof HOUSEHOLD_INCOME_SCHEMA>;

export const HOUSEHOLD_SIZE_SCHEMA = z.number().min(1).max(5);
export type HouseholdSizeType = z.infer<typeof HOUSEHOLD_SIZE_SCHEMA>;

export const DOB_SCHEMA = z.string();
export type DobType = z.infer<typeof DOB_SCHEMA>;

export const TOBACCO_SCHEMA = z.union([z.literal(0), z.literal(1)]);
export type TobaccoType = z.infer<typeof TOBACCO_SCHEMA>;

export const EMAIL_SCHEMA = Email;
export type EmailType = z.infer<typeof EMAIL_SCHEMA>;

export const SESSION_ID_SCHEMA = SessionId;
export type SessionIdType = z.infer<typeof SESSION_ID_SCHEMA>;

export const USER_ID_SCHEMA = UserId;
export type UserIdType = z.infer<typeof USER_ID_SCHEMA>;

export const DOMAIN_SESSION_ID_SCHEMA = DomainSessionId;
export type DomainSessionIdType = z.infer<typeof DOMAIN_SESSION_ID_SCHEMA>;
export const DOMAIN_USER_ID_SCHEMA = DomainUserId;
export type DomainUserIdType = z.infer<typeof DOMAIN_USER_ID_SCHEMA>;

export const AnswersObjectSchema = z
  .object({
    ZIP_CODE: ZIP_CODE_SCHEMA,
    HOUSEHOLD_INCOME: HOUSEHOLD_INCOME_SCHEMA,
    HOUSEHOLD_SIZE: HOUSEHOLD_SIZE_SCHEMA,
    DOB: DOB_SCHEMA,
    TOBACCO: TOBACCO_SCHEMA,
    EMAIL: EMAIL_SCHEMA,
    SESSION_ID: SESSION_ID_SCHEMA,
    USER_ID: USER_ID_SCHEMA,
    DOMAIN_SESSION_ID: DOMAIN_SESSION_ID_SCHEMA,
    DOMAIN_USER_ID: DOMAIN_USER_ID_SCHEMA,
    PLAN_YEAR: PLAN_YEAR_SCHEMA,
  })
  .partial();

export type AnswersObject = z.infer<typeof AnswersObjectSchema>;

export type ResultStatus = 'idle' | 'loading' | 'success' | 'error';
